import React from 'react';
import {
  Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function PublicationsDialog({ open, onClose, publications, onRestore, busy }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('website.versions')}</DialogTitle>
      <DialogContent dividers>
        {(!publications || publications.length === 0) && <ListItemText primary={t('website.no_versions')} />}
        <List dense>
          {(publications || []).map((p) => (
            <ListItem
              key={p.id}
              secondaryAction={!p.is_current ? (
                <Button size="small" onClick={() => onRestore(p.id)} disabled={busy} data-testid={`restore-${p.id}`}>
                  {t('website.restore')}
                </Button>
              ) : <Chip size="small" color="success" label={t('website.current_version')} />}
            >
              <ListItemText
                primary={`${new Date(p.published_at).toLocaleString('fi-FI')} (v${p.content_version})`}
                secondary={t(`website.trigger.${p.trigger}`, { defaultValue: p.trigger })}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('website.close')}</Button>
      </DialogActions>
    </Dialog>
  );
}
